import type { StandardLonghandProperties, StandardShorthandProperties } from "csstype";
import { useMemo } from "react";
import { Color } from "#scripts/lib/types/Color.ts";

const L = (t: number) => `calc(var(--lightness-scale, 1) * ${t} + var(--lightness-adjustment, 0))`;

const DEFAULT_COLOR = Color.make({ chroma: 0.5, hue: 0 });
export type ColorStyles = ReturnType<typeof getColorStyles>;
export function getColorStyles(color: Color) {
  return {
    container: {
      backgroundColor: `oklch(${L(1)} ${color.chroma * 0.2} ${color.hue})`,
      borderColor: `oklch(${L(0.87)} ${color.chroma} ${color.hue})`,
    },
    assocContainer: {
      backgroundColor: `oklch(${L(1)} ${color.chroma * 0.1} ${color.hue})`,
      borderColor: `oklch(${L(0.95)} ${color.chroma * 0.2} ${color.hue})`,
    },
    listItem: {
      backgroundColor: `oklch(${L(0.92)} ${color.chroma * 0.2} ${color.hue})`,
    },
    textPrimary: { color: `oklch(${L(0.4)} ${color.chroma} ${color.hue})` },
    textSecondary: { color: `oklch(${L(0.2)} ${color.chroma * 0.5} ${color.hue})` },
    colorPreview: {
      backgroundColor: `oklch(${L(0.75)} ${color.chroma * 0.8} ${color.hue})`,
    },
  } satisfies Record<string, StandardLonghandProperties & StandardShorthandProperties>;
}

export function useColorStyles(color = DEFAULT_COLOR) {
  return useMemo(() => getColorStyles({ chroma: color.chroma, hue: color.hue }), [color.chroma, color.hue]);
}
